<template>
    <div class="close animated" :class="{fadeInLeft:projectOpened,'hide-close':!projectOpened}" @click="close">
        <i class="iconfont icon-guanbi"></i>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "close-details",
        methods: {
            close: function () {
                this.$store.commit('projectSwitch');
                this.$store.commit('componentsSwitch', 'imageList');
                this.$store.commit('setShowContent', false);
            }
        },
        computed: {
            ...mapGetters([
                'projectOpened', 'media'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .close {
        position: absolute;
        width: 50px;
        height: 50px;
        line-height: 45px;
        left: 625px;
        top: 80px;
        border-radius: 100px;
        background: #fff;
        box-shadow: 1px 1px 8px #ccc;
        cursor: pointer;
        font-size: 30px;
        text-align: center;
        opacity: 0;
        z-index: 100;
    }
    .hide-close{
        display: none;
    }
</style>